<template>
    <DefaultHeader />
    <div class="container-fluid">
        <div class="row mt-5 d-flex justify-content-center">
            <div class="col-5">
                <div class="row d-flex justify-content-center">
                    <div class="col-auto">
                        <input v-model="name" type="text" class="form-control" placeholder="Nouveau profil">
                    </div>
                    <div class="col-auto">
                        <ButtonDisplay
                        :type="'add'"
                        @click="createProfile()"/>
                    </div>
                </div>
            </div>
            <div class="col-1">
                <ButtonDisplay
                v-if="this.changed"
                :type="'register'"
                :text="'Enegistrer'"
                @click="this.save()" />
            </div>
            <div class="col-5">
                <div class="row d-flex justify-content-center">
                    <div class="col-auto">
                        <SearchDisplay :searchFunction="'searchWord'" @searchWord="refreshData"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-5 mb-lg-5">
                <ProfilesComponent :profiles="this.badgeProfiles" :selectedId="this.selectedProfileId" @select="selectProfile" @saveProfile="saveProfile" @deleteProfile="deleteProfile"/>
            </div>
            <div class="col-1"></div>
            <div class="col-5 mb-lg-5">
                <BalisesComponent :balises="this.balises" :loading="this.balisesLoading" @change="this.changed=true" ref="balisesComp"/>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>
    
<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import ProfilesComponent from './Sections/ProfilesComponent.vue'
import BalisesComponent from './Sections/BalisesComponent.vue'
import BaliseService from '@/services/balise.service.js'
import BadgeService from '@/services/badge.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import SearchDisplay from '@/components/display/SearchDisplay.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        ProfilesComponent,
        BalisesComponent,
        ButtonDisplay,
        SearchDisplay
    },
    data() {
        return {
            name: null,
            badgeProfiles: null,
            balises: null,
            balisesLoading: false,
            selectedProfileId: null,
            changed: false
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData(searchInput = null) {
            BadgeService.getClientBadgeProfiles()
            .then(response => {
                this.badgeProfiles = FormatHelper.badgeProfilesResponseFormat(response.data);
            })
            .catch(e => {
                console.log(e);
            });

            BaliseService.getGroupBalisesLastPositions(searchInput, 1)
            .then(response => {
                this.balises = FormatHelper.balisesResponseFormat(response.data);
                if(this.selectedProfileId != null)
                    this.selectProfile(this.selectedProfileId)
            })
            .catch(e => {
                console.log(e);
            });
        },
        createProfile() {
            BadgeService.createProfile(this.name)
            .then(() => {
                this.refreshData();
            })
            .catch(e => {
                console.log(e);
            });
            this.name = "";
        },
        selectProfile(id) {

            this.selectedProfileId = id;
            this.balisesLoading = true;

            this.balises.forEach(balise => {
                balise.checked = false
            });

            BadgeService.getProfile(id)
            .then(response => {
                response.data.balises.forEach(selectedBalise => {
                    this.balises.forEach(balise => {
                        if(selectedBalise.id == balise.id)
                            balise.checked = true
                    });
                });
                this.balisesLoading = false;
                this.changed = false;
                this.$refs.balisesComp.globalCheck = false;
            })
            .catch(e => {
                console.log(e);
            });
        },
        save() {
            var ids = []
            this.balises.forEach(balise => {
                if(balise.checked)
                    ids.push(balise.id)
            });

            BadgeService.saveProfileBalises(this.selectedProfileId, ids)
            .then(() => {
                this.selectProfile(this.selectedProfileId);
                this.changed = false;
            })
            .catch(e => {
                console.log(e);
            });
        },
        saveProfile(id, name) {
            BadgeService.updateProfile({id: id, name: name})
            .then(() => {
                this.refreshData();
            })
            .catch(e => {
                console.log(e);
            });
        },
        deleteProfile(id) {
            BadgeService.deleteProfile(id)
            .then(() => {
                this.refreshData()
            })
            .catch(e => {
                console.log(e);
            });
        }
    }
}
</script>